import ApiBase from './ApiBase';

export default class OrderService extends ApiBase {
  async find(email, orderNumber) {
    const { data } = await this.client.get(`/order-lookup?email=${email.trim()}&order=${orderNumber.trim()}`);

    return data;
  }

  async getProducts(productName, storeId) {
    const { data } = await this.client.get(`/orders/${storeId}/products/query?name=${productName}`);

    return data;
  }
}
